module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_8023.80ce44f4.png";